import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";

export default function ContactPage() {
  const [p, setP] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setP(r.data.property)); }, []);
  if (!p) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">Get in touch</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-12">Contact your host</h1>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="card"><Phone size={22} style={{ color: "var(--terracotta)" }} /><div className="font-serif text-2xl mt-3 mb-1">Phone</div><a data-testid="contact-phone" href={`tel:${p.phone}`}>{p.phone}</a></div>
          <div className="card"><MessageCircle size={22} style={{ color: "var(--terracotta)" }} /><div className="font-serif text-2xl mt-3 mb-1">WhatsApp</div><a data-testid="contact-whatsapp" href={`https://wa.me/${p.whatsapp.replace(/\D/g, "")}`}>{p.whatsapp}</a></div>
          {p.email && (
          <div className="card"><Mail size={22} style={{ color: "var(--terracotta)" }} /><div className="font-serif text-2xl mt-3 mb-1">Email</div><a data-testid="contact-email" href={`mailto:${p.email}`}>{p.email}</a></div>
          )}
          <div className="card"><MapPin size={22} style={{ color: "var(--terracotta)" }} /><div className="font-serif text-2xl mt-3 mb-1">Address</div><div data-testid="contact-address">{p.address}<br />{p.city}, {p.state} {p.pincode}</div>
          {p.get_directions_enabled !== false && p.google_maps_url && (
            <a data-testid="get-directions" href={p.google_maps_url} target="_blank" rel="noopener noreferrer" className="btn-primary inline-flex items-center gap-2 mt-4"><MapPin size={16} /> Get Directions</a>
          )}
          </div>
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
